/* RW14 2026-10-03 (Rubber Washer Warehouse staging): accessibility and phone buying helpers.
   1. Landmarks: the skip link goes in its own <nav>; the announcement bar, the header/footer "icons with text" strips and other top-level sections that sit
      outside <header>/<main>/<footer> become labelled regions (axe "region").
   2. Sideways-scrolling sliders with nothing focusable inside get tabindex=0 so keyboard users can scroll them.
   3. Main menu: two store-menu items point at "http://size-finder" and "http://rubber-washer-size-chart" (no domain);
      they are pointed at /pages/<handle>. Top-level "#" items never jump to the page top, and a desktop click no longer shuts a hover-opened dropdown.
   4. Product pages on phones: a fixed quick-buy bar with the per-piece price, stock or sold-out state, the $5.00
      per-line minimum and Add to cart (clicks the real form button) or Notify me (scrolls to the existing form).
   5. Round 8 fixes: unique names for the two search forms on /search; image-less article cards drop their empty duplicate
      link from the tab order; the home H1 sits on slide 1 of an autoplaying slideshow that is aria-hidden while slide 2
      shows, so a visually hidden copy of the H1 is exposed only while slide 1 is hidden; the dimmed (40 %) quantity box on
      sold-out products is raised to 75 % opacity (text 6.3:1). */
(function () {
  'use strict';
  var d = document;
  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }

  function landmarks() {
    var sk = d.querySelector('body > a.skip-link');
    if (sk) { var nv = d.createElement('nav'); nv.setAttribute('aria-label', 'Skip link'); sk.parentNode.insertBefore(nv, sk); nv.appendChild(sk); }
    var LM = 'header,main,footer,nav,aside,[role=banner],[role=main],[role=contentinfo],[role=navigation],[role=region],[role=complementary],[role=dialog],dialog';
    var secs = d.querySelectorAll('body > .shopify-section, body > div > .shopify-section, .shopify-section-group-header-group, .shopify-section-group-footer-group');
    Array.prototype.forEach.call(secs, function (s) {
      if (s.closest(LM) && s.closest(LM) !== s) return;
      if (s.querySelector(LM) || s.getAttribute('role')) return;
      if (!txt(s)) return;
      var h = s.querySelector('h1,h2,h3');
      var name = h ? txt(h).slice(0, 60) : /announcement/.test(s.id) ? 'Announcements'
        : s.classList.contains('shopify-section-group-header-group') ? 'Store highlights'
        : s.classList.contains('shopify-section-group-footer-group') ? 'Help and support' : 'Store information';
      s.setAttribute('role', 'region');
      s.setAttribute('aria-label', uniq(name));
    });
  }
  // Landmarks of one kind need distinct names (axe "landmark-unique").
  var used = {};
  function uniq(n) { var k = n, i = 2; while (used[k]) k = n + ' ' + i++; used[k] = 1; return k; }

  function sliders() {
    Array.prototype.forEach.call(d.querySelectorAll('.slider, [data-hub-box]'), function (el) {
      if (el.scrollWidth <= el.clientWidth + 1 && el.scrollHeight <= el.clientHeight + 1) return;
      if (el.hasAttribute('tabindex') || el.querySelector('a[href],button,input,select,textarea,[tabindex]')) return;
      el.setAttribute('tabindex', '0');
      if (!el.getAttribute('role')) el.setAttribute('role', 'region');
      if (!el.getAttribute('aria-label')) {
        var r = el.closest('[aria-label]');
        el.setAttribute('aria-label', uniq((r ? r.getAttribute('aria-label') : 'List') + ', scrolls sideways'));
      }
    });
  }

  function menu() {
    Array.prototype.forEach.call(d.querySelectorAll('a[href^="http://"]'), function (a) {
      var m = /^http:\/\/([a-z0-9-]+)\/?$/i.exec(a.getAttribute('href'));
      if (m) a.setAttribute('href', '/pages/' + m[1].toLowerCase());
    });
    Array.prototype.forEach.call(d.querySelectorAll('.main-nav__row > a[href="#"]'), function (a) {
      var btn = a.parentNode.querySelector('.js-toggle');
      if (!btn) return;
      a.setAttribute('role', 'button');
      a.setAttribute('aria-controls', btn.getAttribute('aria-controls') || '');
      // The theme already opens the submenu when its "#" label is clicked or tapped. Two fixes only:
      // the "#" never jumps the page, and on desktop (where hover has already opened it) a mouse click
      // no longer toggles the dropdown shut again. Space activates it like a button.
      a.addEventListener('click', function (e) {
        e.preventDefault();
        if (e.detail > 0 && btn.getAttribute('aria-expanded') === 'true' && window.matchMedia('(min-width: 768px)').matches) e.stopPropagation();
      });
      a.addEventListener('keydown', function (e) { if (e.key === ' ') { e.preventDefault(); a.click(); } });
    });
  }

  // Escape closes the phone menu and returns focus to its button.
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var b = d.querySelector('.main-menu__toggle[aria-expanded="true"]');
    if (b && b.offsetParent) { b.click(); b.focus(); }
  });

  function extras() {
    var forms = d.querySelectorAll('form[role="search"]:not([aria-label])');
    if (forms.length > 1) Array.prototype.forEach.call(forms, function (f) {
      f.setAttribute('aria-label', uniq(f.closest('header, .shopify-section-group-header-group') ? 'Store search' : 'Search results search'));
    });
    Array.prototype.forEach.call(d.querySelectorAll('a.card__media'), function (a) {
      if (txt(a) || a.querySelector('img,svg,[aria-label]') || a.getAttribute('aria-label')) return;
      a.setAttribute('tabindex', '-1'); a.setAttribute('aria-hidden', 'true');
    });
    var h1s = d.querySelectorAll('h1');
    if (h1s.length === 1) {
      var slide = h1s[0].closest('.slideshow__slide');
      if (slide && slide.parentNode && slide.parentNode.querySelectorAll('.slideshow__slide').length > 1) {
        var copy = d.createElement('h1');
        copy.className = 'visually-hidden';
        copy.textContent = txt(h1s[0]);
        var main = d.querySelector('main') || d.body;
        main.insertBefore(copy, main.firstChild);
        var sync = function () { var hid = slide.getAttribute('aria-hidden') === 'true'; if (hid) copy.removeAttribute('aria-hidden'); else copy.setAttribute('aria-hidden', 'true'); };
        sync();
        new MutationObserver(sync).observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
      }
    }
  }
  function dimQty() {
    Array.prototype.forEach.call(d.querySelectorAll('quantity-input'), function (q) {
      if (parseFloat(getComputedStyle(q).opacity) < 0.75) q.style.opacity = '0.75';
    });
  }

  function money(c) { return '$' + (c / 100).toFixed(2); }

  function buyBar() {
    if (!d.body.classList.contains('template-product') && !/\/products\//.test(location.pathname)) return;
    var form = d.querySelector('.js-product-form-main');
    if (!form) return;
    var add = form.querySelector('[name="add"]');
    var bar = d.createElement('div');
    bar.className = 'rbb';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Quick buy');
    bar.innerHTML = '<div class="rbb__i"><p class="rbb__p" data-p></p><p class="rbb__m" data-m></p></div><button type="button" class="rbb__b" data-b></button>';
    var P = bar.querySelector('[data-p]'), M = bar.querySelector('[data-m]'), B = bar.querySelector('[data-b]');
    var state = {};
    function variant() {
      var s = d.querySelector('.product-info variant-picker script[type="application/json"], variant-picker script[type="application/json"]');
      try { return s ? JSON.parse(s.textContent) : null; } catch (e) { return null; }
    }
    function qtyInput() { return d.querySelector('.js-product-form-main [name="quantity"]') || d.querySelector('[name="quantity"][form]'); }
    // QF 2026-10-03: "$x each" and "Add N · $X" used the list price, but the Bulk Tier Pricing app takes 5-25 % off at
    // 100+ (Add 1000 said $230.00, the app $184.00). Use the app's own tiers ([data-qb-data]) and its formula
    // (unit = price x (1 - pct/100), total = unit x qty). No tier data: list price, as before.
    function tier(v, q) {
      var els = d.querySelectorAll('[data-qb-root] [data-qb-data]');
      for (var i = 0; i < els.length; i++) {
        var j; try { j = JSON.parse(els[i].textContent); } catch (e) { continue; }
        if (!j || !j.tiers || !j.variants || !j.variants.some(function (x) { return String(x.id) === String(v.id); })) continue;
        var base = v.price / 100, unit = base, min = 0;
        j.tiers.forEach(function (x) {
          if (q >= x.minQty && x.minQty >= min) { min = x.minQty;
            unit = x.type === 'percentage' ? base * (1 - x.value / 100) : x.type === 'amountOff' ? Math.max(0, base - x.value) : x.value; }
        });
        return { each: Math.round(+unit.toFixed(2) * 100), total: Math.round(+(unit * q).toFixed(2) * 100) };
      }
      return { each: v.price, total: v.price * q };
    }
    function render() {
      dimQty();
      var v = variant();
      if (!v) { bar.classList.add('is-off'); return; }
      var q = Math.max(1, parseInt((qtyInput() || {}).value, 10) || 1);
      var stock = d.querySelector('.product-info .js-inventory-notice, .product-info .product-inventory__status');
      var stockTxt = stock && stock.offsetParent ? txt(stock) : '';
      var mat = v.option1 || v.title || '';
      state = { v: v, q: q };
      if (v.available) {
        var tp = tier(v, q);
        P.innerHTML = '<strong></strong> each · <span class="rbb__ok"></span>';
        P.querySelector('strong').textContent = money(tp.each);
        P.querySelector('span').textContent = stockTxt ? stockTxt.toLowerCase() : 'in stock';
        var pre = mat ? mat + ' · ' : '';
        if (v.price > 0 && v.price < 500) {
          var need = Math.ceil(500 / v.price);
          M.textContent = pre + (q * v.price >= 500 ? q + ' pcs meets $5 min' : '$5 min per item: ' + need + '+ pcs');
        } else M.textContent = pre + 'free US shipping on $25+';
        B.className = 'rbb__b';
        B.textContent = 'Add ' + q + ' · ' + money(tp.total);
        B.setAttribute('aria-label', 'Add ' + q + ' to cart, ' + money(tp.total));
      } else {
        P.innerHTML = '<strong></strong> each · <span class="rbb__no"></span>';
        P.querySelector('strong').textContent = money(v.price);
        P.querySelector('span').textContent = 'sold out';
        M.textContent = (mat ? mat + ': ' : '') + 'get a back-in-stock email';
        B.className = 'rbb__b rbb__b--n';
        B.textContent = 'Notify me';
        B.removeAttribute('aria-label');
      }
    }
    B.addEventListener('click', function () {
      if (state.v && state.v.available && add && !add.disabled) { add.click(); return; }
      var n = d.getElementById('rww-notify') || d.getElementById('variants');
      if (n) {
        n.scrollIntoView({ block: 'center', behavior: 'smooth' });
        var f = n.querySelector('input[type="email"]');
        if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 400);
      }
    });
    d.body.appendChild(bar);
    d.body.classList.add('has-rbb');
    render();
    var t;
    function later() { clearTimeout(t); t = setTimeout(render, 60); }
    var info = d.querySelector('.product-info') || form;
    new MutationObserver(later).observe(info, { childList: true, subtree: true, characterData: true });
    d.addEventListener('change', later, true);
    d.addEventListener('input', later, true);
    d.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.rqp, .qty-input')) later(); }, true);
    // Hide while the real buy box (form + notify card) is on screen, so the two never show at once.
    if ('IntersectionObserver' in window) {
      var seen = new Set();
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); });
        bar.classList.toggle('is-off', seen.size > 0);
      });
      [add, d.getElementById('rww-notify')].forEach(function (el) { if (el) io.observe(el); });
    }
  }

  function run() { landmarks(); menu(); extras(); dimQty(); sliders(); buyBar(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', sliders);
})();
